import React, { useContext } from 'react';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import { CreateTeaserContext, ICreateTeaserContext } from '../../createTeaserState/createTeaserContext';
import style from './ControlPanel.module.scss';

const ControlPanel: React.FC = () => {
	const { changeVisibleForm, visibleForm } = useContext<ICreateTeaserContext>(CreateTeaserContext);

	return (
		<div className={style.container} data-test="ControlPanel">
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('mainForm')}
				isActive={visibleForm === 'mainForm'}
				btnName="mainInfoBookmark"
			/>
			{/* <PageBookmarkBtn
				onClick={() => changeVisibleForm('translations')}
				isActive={visibleForm === 'translations'}
				btnName="translationsBookmark"
			/> */}
		</div>
	);
};

export default ControlPanel;
